import { css } from 'linaria';

export const galleryTabs = css`
  && {
    margin-bottom: 32px;

    && button {
      @media (--only-mobile) {
        padding: 9px 20px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const galleryGrid = css`
  && {
    grid-auto-rows: 380px;
    margin-bottom: 32px;

    @media (--only-tablet) {
      grid-auto-rows: 216px;
    }

    @media (--only-mobile) {
      grid-auto-rows: 216px 216px 216px 376px 216px 216px 216px 376px 216px 216px;
    }
  }
`;

export const galleryImageBlock = css`
  padding: 0;
  font-family: inherit;
  border: none;
  border-radius: var(--rounding-l);
  cursor: pointer;

  @media (--from-tablet) {
    &:nth-of-type(10n + 4) {
      grid-row-start: span 2;
    }

    &:nth-of-type(10n + 8) {
      grid-row-start: span 2;
    }
  }

  @media (--only-mobile) {
    &:nth-of-type(10n + 4) {
      height: 376px;
    }

    &:nth-of-type(10n + 8) {
      height: 376px;
    }
  }
`;

export const galleryImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l);
  object-fit: cover;
`;

export const galleryMoreButton = css`
  display: block;
  width: max-content;
  margin: 0 auto;

  @media (--only-mobile) {
    width: 100%;
  }
`;
